// extracted by mini-css-extract-plugin
module.exports = {"content":"account-type-banner_content__33Fpv"};